import styles from './styles/services.module.css'
import FAB from '../../helpers/fab'

export default function Services() {
  const isMobile = window.innerWidth < 667;

  //Styles
  const serviceHighlightBoxFadeLeft = `${styles.serviceHighlightBox} ${styles.fadeInLeft}`;
  const serviceHighlightBoxFadeRight = `${styles.serviceHighlightBox} ${styles.fadeInRight}`;

  return (
    <section className={styles.servicesHighlight}>
        <h2>Our Services</h2>
        <div className="container">
            <div className={serviceHighlightBoxFadeLeft}>
                <div className={styles.serviceHighlightText}>
                    <h3>Kitchens</h3>
                    <p>
                        We specialize in full kitchen design, layout planning, and final installation. Let us turn your kitchen dreams into reality.
                    </p>
                </div>
                <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/fullkitchen.png" alt="Full Kitchens" />
                </div>
            </div>

            <div className={serviceHighlightBoxFadeLeft}>
                {!isMobile && <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/countertop.png" alt="Countertops" />
                </div>}
                <div className={styles.serviceHighlightText}>
                    <h3>Countertops</h3>
                    <p>
                        Choose from a wide variety of beautiful and durable countertops including quartz and laminate. We offer professional installation and custom cuts to match your space.
                    </p>
                </div>
                {isMobile && <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/countertop.png" alt="Countertops" />
                </div>}
            </div>

            <div className={serviceHighlightBoxFadeRight}>
                <div className={styles.serviceHighlightText}>
                    <h3>Bathrooms</h3>
                    <p>
                        From full bathroom cabinetry to countertops, we design and install solutions tailored to your needs—bringing functionality and luxury to your bathroom.
                    </p>
                </div>
                <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/bathroom.png" alt="Bathrooms" />
                </div>
            </div>

            <div className={serviceHighlightBoxFadeRight}>
                {!isMobile && <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/commercial.png" alt="Commercial" />
                </div>}
                <div className={styles.serviceHighlightText}>
                    <h3>Multi-Unit Kitchens and Vanities</h3>
                    <p>
                        Whether you're managing a large-scale development or outfitting hospitality or retail facilities, our team specializes in delivering high-quality, custom-built commercial kitchens and vanities tailored to meet the unique needs of multi-unit projects.
                    </p>
                </div>
                {isMobile && <div className={styles.serviceHighlightImage}>
                    <img src="https://ik.imagekit.io/1stopkitchens/images/services/all-services/commercial.png" alt="Commercial" />
                </div>}
            </div>
        </div>
        
        <FAB />
    </section>
  );
}
